import { Controller } from "@hotwired/stimulus"

// Hides the native file picker control and treats one shared button as both
// "choose files" and "upload". Selecting files submits the form.
export default class extends Controller {
  static targets = ["input", "button", "names"]

  pick(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  changed() {
    const files = Array.from(this.inputTarget.files || [])
    if (this.hasNamesTarget) {
      this.namesTarget.textContent = files.map((file) => file.name).join(", ")
    }
    if (files.length === 0) return

    if (this.hasButtonTarget) {
      const uploading = this.buttonTarget.dataset.disableWith
      if (uploading) this.buttonTarget.textContent = uploading
      this.buttonTarget.disabled = true
    }

    this.element.requestSubmit()
  }
}
